import Types from "./Types";

const INITIAL_STATE = {
  questionsBank: [],
  questionBank: {},
  isLoading: false,
  suspendLoading: false,
  bookmarkLoading: false,
  count: "",
  superadminQuestionsBank: [],
};

export default function superadminQuestionsBank(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_ALL_SUPERADMIN_QUESTIONS_BANK_SUCCESS: {
      return {
        ...state,
        questionsBank: payload.data,
        count: payload.data.length,
        superadminQuestionsBank: payload.data,
      };
    }
    case Types.GET_SUPERADMIN_QUESTIONS_BANK_SUCCESS: {
      return {
        ...state,
        questionsBank: payload.data,
        count: payload.data.length,
        superadminQuestionsBank: payload.data,
      };
    }

    case Types.GET_SUPERADMIN_QUESTION_BANK_SUCCESS: {
      return {
        ...state,
        questionBank: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_QUESTION_BANK_SUCCESS: {
      let data = payload.data;
      const questionsBank = state.questionsBank;
      let idx = 0;
      questionsBank.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      questionsBank[idx] = data;
      return {
        ...state,
        questionsBank: questionsBank,
        superadminQuestionsBank: questionsBank,
      };
    }

    // create
    case Types.CREATE_SUPERADMIN_QUESTION_BANK_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.questionsBank.slice();
      let index = state.questionsBank.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        questionsBank: newArray,
        superadminQuestionsBank: newArray,
      };
    }
    case Types.ADD_SUPERADMIN_QUESTION_BANK_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_QUESTION_BANK_SUCCESS: {
      let id = payload.payload;
      console.log('payload', payload);
      let data = payload.result?.data?.data;
      console.log('data', data);
      console.log('deleted_at from API:', data?.deleted_at);
      let questionsBank = state.questionsBank;
      let idx = 0;
      questionsBank.forEach((table, index) => {
        if (table.id === id) {
          idx = index;
          return;
        }
      });

      if (questionsBank[idx] && data) {
        // Use the deleted_at value from the API response
        questionsBank[idx].deleted_at = data.deleted_at;
        console.log('Updated deleted_at to:', questionsBank[idx].deleted_at);
      }
      return {
        ...state,
        questionsBank: questionsBank,
        superadminQuestionsBank: questionsBank,
      };
    }
    case Types.BOOKMARK_SUPERADMIN_QUESTION_BANK_SUCCESS: {
      let id = payload.payload;
      let data = payload.result?.data?.data || payload.result?.data || payload.result;
      const questionsBank = state.questionsBank;
      let idx = 0;
      questionsBank.forEach((table, index) => {
        if (table.id === id) {
          idx = index;
          return;
        }
      });

      if (questionsBank[idx]) {
        questionsBank[idx].book_marked = data?.book_marked;
      }
      return {
        ...state,
        questionsBank: questionsBank,
        superadminQuestionsBank: questionsBank,
      };
    }

    case Types.BOOKMARK_SUPERADMIN_QUESTION_BANK_LOADING: {
      return {
        ...state,
        bookmarkLoading: payload,
      };
    }

    case Types.SUSPEND_SUPERADMIN_QUESTION_BANK_LOADING: {
      return {
        ...state,
        suspendLoading: payload,
      };
    }
    default: {
      return state;
    }
  }
}
